import { Text } from '@chakra-ui/react'
import { TextProps } from './utils'

const Body2 = ({ children, color, ...textProps }: TextProps) => (
  <Text as="p" fontSize="sm" fontWeight={400} color={color} {...textProps}>
    {children}
  </Text>
)

export { Body2 }
